<template>
  <div class="mic_container">
      <div v-if="trainingPage">
        <iframe
            :src="trainingPage"
            style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:90%; border:none; margin: 75px 0px 50px 0px; padding:0; overflow:hidden;"
            frameborder="0" >
           </iframe>
      </div>
    <div v-if="errorPage" v-html="errorPage"></div>
  </div>
</template>

<script>
import {trainingService} from '../_services'
export default {
  data () {
    return {
      trainingPage: '',
      errorPage: ''
    }
  },
  beforeMount () {
    var id = this.$route.params.id
    trainingService.getTraining(id)
      .then(
        response => {
          console.log(response);
          this.trainingPage = response.data
          // window.location.href = response.data
        },
        error => {
          console.log(error)
          this.errorPage = '<h1 style="padding:25px;">Das von Ihnen gesuchte Training konnte leider nicht gefunden werden.</h1>'
        }
      )
  }
}
</script>

<style scoped="true">
.container {
  max-width: 100vh !important;
}
</style>



// WEBPACK FOOTER //
// src/training/TrainingPage.vue